$(function() {
    $( ".content table" ).wrap( "<div class='table-wrapper'></div>" );
});
